const checkIsAdultPassengerType = (p) => {
  return (
    (p?.passengerType || '').toLowerCase().startsWith('adult') ||
    (p?.passengerTypeCode || '').toUpperCase() === 'ADT'
  );
};

export default checkIsAdultPassengerType;
